export default __webpack_public_path__ + "static/media/Floors.7fc9bbb5.png";